import { useCallback, useContext } from 'react';
import { getExactKeyPath, getRealPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { isConditionsPseudoGroup } from '../strategy/eventBasedFilters';
import { getActiveFieldsTooltips } from '../utils/activeFields';
import { isPropertyChangedEventTypeId } from '../strategy/propertyChangedFilterUtils';
import { isOperator } from '../filterQueryFormat/operator/Operator';
const getFilterTarget = (filterFamily, conditionToRefineKeyPath, draftCondition, internalDraftValue) => {
  if (conditionToRefineKeyPath && isConditionsPseudoGroup(filterFamily)) {
    return internalDraftValue.getIn(getRealPath(conditionToRefineKeyPath));
  }
  if (draftCondition && isPropertyChangedEventTypeId(filterFamily)) {
    const maybeTarget = getExactKeyPath(draftCondition.conditionPath, internalDraftValue);
    if (isOperator(maybeTarget)) {
      return getExactKeyPath(draftCondition.conditionPath.pop(), internalDraftValue);
    }
    return maybeTarget;
  }
  return undefined;
};
export const useActiveFields = filterFamily => {
  const {
    conditionToRefineKeyPath,
    draftCondition,
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const disableActiveFields = useCallback(fields => {
    if (!fields) {
      return fields;
    }

    // place where to look for already selected fields
    const filterTarget = getFilterTarget(filterFamily, conditionToRefineKeyPath, draftCondition, internalDraftValue);

    // already selected fields with tooltips
    const activeFieldsTooltips = getActiveFieldsTooltips(filterFamily, filterTarget);

    // disable already selected fields and add tooltip
    return fields.map(field => {
      // @ts-expect-error ts-migrate(2339) FIXME
      const activeFieldTooltip = activeFieldsTooltips[field.get('name')];
      if (activeFieldTooltip) {
        return field.merge({
          disabled: true,
          tooltip: activeFieldTooltip
        });
      }
      return field;
    });
  }, [filterFamily, conditionToRefineKeyPath, draftCondition, internalDraftValue]);
  const disableGroupedActiveFields = useCallback(groups => {
    if (groups) {
      return groups.map(group => {
        return group.set('properties', disableActiveFields(group.properties));
      });
    }
    return undefined;
  }, [disableActiveFields]);
  return {
    disableActiveFields,
    disableGroupedActiveFields
  };
};